import React from 'react';
import { strengths } from '../data/siteData';
import SectionTitle from './SectionTitle';
import Reveal from './Reveal';

const StrengthSection = () => (
  <section className="strength section">
    <div className="container">
      <div className="strength__heading">
        <SectionTitle label="OUR STRENGTH" title={<>選ばれる理由を、<br />仕組みにする。</>} />
        <Reveal as="p" className="strength__intro" delay={120}>
          商品力だけでは、継続的な信頼は生まれない。
          <br />
          RYUは、供給力・スピード・ネットワーク・提案力を磨き続けています。
        </Reveal>
      </div>

      <div className="strength__list">
        {strengths.map((item, index) => (
          <Reveal as="article" className="strength-item" delay={index * 80} key={item.english}>
            <span className="strength-item__number">{item.number}</span>
            <div>
              <p>{item.english}</p>
              <h3>{item.title}</h3>
            </div>
            <p className="strength-item__description">{item.description}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default StrengthSection;
